"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
// TODO remove default export
// eslint-disable-next-line no-restricted-exports
var SDK_1 = require("./SDK");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return SDK_1.SDK; } });
//# sourceMappingURL=index.js.map